import { createModule } from "@wertarbyte/module-loader";

export default createModule("pokemons", {});
